
    export default {
        regex(value, pattern){
            return value.match(pattern);
        }
    }
    
